import { create } from "zustand";

type RequestLog = {
  correlationId: string;
  url: string;
  at: number;
};

type TelemetryState = {
  requestLog: RequestLog[];
  track: (entry: RequestLog) => void;
  clear: () => void;
};

const MAX_LOG_ENTRIES = 50;

export const useTelemetryStore = create<TelemetryState>((set) => ({
  requestLog: [],
  track: (entry) =>
    set((state) => {
      const next = [entry, ...state.requestLog];
      if (next.length > MAX_LOG_ENTRIES) {
        next.length = MAX_LOG_ENTRIES;
      }
      return { requestLog: next };
    }),
  clear: () => set({ requestLog: [] })
}));

export function trackCorrelationId(correlationId: string, url: string) {
  useTelemetryStore.getState().track({ correlationId, url, at: Date.now() });
}






